import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createPortal } from 'react-dom';
import { css } from '@emotion/react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import { type RootState } from '@editor2/reducers/root';
import { showToast, type ToastState } from '@editor2/reducers/toastSlice';

const ToastContainer = () => {
	const { toast } = useSelector((state: RootState) => state);

	const dispatch = useDispatch();

	const [toasts, setToasts] = useState<ToastState[]>([]);

	const createHandleToastClose = useCallback(
		(index: number) => () => {
			setToasts((prevToasts) => prevToasts.toSpliced(index, 1));
			dispatch(showToast({ message: null }));
		},
		[dispatch]
	);

	useEffect(() => {
		if (toast.message) {
			setToasts((prevToasts) => [...prevToasts, toast]);
		}
	}, [toast]);

	return createPortal(
		<div css={styles.self}>
			{toasts.map((item, i) => (
				<Snackbar
					key={i}
					open={true}
					autoHideDuration={5000}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					onClose={createHandleToastClose(i)}>
					<Alert
						elevation={6}
						variant="filled"
						severity={item.severity}
						onClose={createHandleToastClose(i)}>
						{item.message}
					</Alert>
				</Snackbar>
			))}
		</div>,
		document.body
	);
};

const styles = {
	self: css`
		display: flex;
		flex-direction: column;
		align-items: center;
		right: 10px;
		position: fixed;
		bottom: 10px;
		z-index: 1100;
	`
};

export default ToastContainer;
